/* eslint-disable no-console */
import { useEffect, useMemo, useState } from "react";

import config from "config";

import { datadogRum } from "@datadog/browser-rum";

export function useScreenRecorder() {
  const [isDatadogReady, setDatadogReady] = useState(false);

  useEffect(() => {
    if (config.datadog && config.isSessionRecordingOn) {
      datadogRum.onReady(() => {
        setDatadogReady(true);
      });
    }
  }, []);

  return useMemo(() => {
    const emptyRecorder = {
      startRecording: () => {
        console.debug("Empty Screen Recorder", "call startRecording");
      },
      stopRecording: () => {
        console.debug("Empty Screen Recorder", "call stopRecording");
      },
    };

    const ddRecorder = {
      startRecording: () => {
        console.debug("DD Screen Recorder", "call startRecording");
        datadogRum.startSessionReplayRecording();
      },
      stopRecording: () => {
        console.debug("DD Screen Recorder", "call stopRecording");
        datadogRum.stopSessionReplayRecording();
      },
    };

    return isDatadogReady ? ddRecorder : emptyRecorder;
  }, [isDatadogReady]);
}

export default useScreenRecorder;
